var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['error-message', { 'error-message--full-width': _vm.fullWidth }]},[_c('error-icon',{staticClass:"error-icon"}),_c('typography',{attrs:{"type":"small-p","no-margin":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }